import React from "react";
import { FiCalendar, FiTag } from "react-icons/fi";
import "./FeaturedBlog.css";

const FeaturedBlog = ({ blog }) => {
  return (
    <div className="featured-blog">
      <div className="featured-image">
        <img src={blog.image} alt={blog.title} />
      </div>
      <div className="featured-content">
        <div className="meta-info">
          <div className="meta-item">
            <FiCalendar />
            <span>{blog.date}</span>
          </div>
          <div className="divider" />
          <div className="meta-item">
            <FiTag />
            <span>{blog.category}</span>
          </div>
        </div>

        <h2>{blog.title}</h2>
        <a href="/">Daha Fazla Göster →</a>
      </div>
    </div>
  );
};

export default FeaturedBlog;
